var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 29,
    viewBox: "0 0 18 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1645 1.31641H12.8147C10.892 1.31641 9.04798 2.01656 7.6884 3.26285C6.32881 4.50913 5.56501 6.19946 5.56501 7.96198V11.9493H1.21518V17.2658H5.56501V27.8987H11.3648V17.2658H15.7146L17.1645 11.9493H11.3648V7.96198C11.3648 7.60947 11.5175 7.27141 11.7895 7.02215C12.0614 6.77289 12.4302 6.63286 12.8147 6.63286H17.1645V1.31641Z",
    stroke: "white",
    strokeWidth: 1.51899,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/Vector (1).2a5ac67eea76e26d2014002306bda3cf.svg";
export { ForwardRef as ReactComponent };